import React, { Component, Fragment } from 'react';
import {
    List,
    TextField,
    EmailField,
    // ReferenceField,
    // DateField,
    Filter,
    Pagination,
    SearchInput,
    Datagrid,
    ReferenceInput,
    SelectInput,
    DeleteButton,
    BulkDeleteButton,
    ShowButton,
    Show,
    SimpleShowLayout,
    ArrayField,
    SingleFieldList,
    ChipField,
    ListButton,
} from 'react-admin';

const CrashReportFilters = (props) => (
    <Fragment>
        <Filter {...props}>
            <SearchInput source="q" alwaysOn />
            <ReferenceInput label="By User" source="byUser" reference="HEXSelector/Reporting/Users">
                <SelectInput optionText="email"></SelectInput>
            </ReferenceInput>
            <ReferenceInput label="By Version" source="byVersion" reference="HEXSelector/Reporting/Versions">
                <SelectInput optionText="version"></SelectInput>
            </ReferenceInput>
            <ReferenceInput label="By Type" source="byType" reference="HEXSelector/Reporting/Types">
                <SelectInput optionText="type"></SelectInput>
            </ReferenceInput>
            <ReferenceInput label="By Top of Stack" source="byTopOfStack" reference="HEXSelector/Reporting/TopOfStack">
                <SelectInput optionText="top"></SelectInput>
            </ReferenceInput>
        </Filter>
    </Fragment>
)

const CrashReportActions = (props) => (
    <Fragment>
        <BulkDeleteButton {...props} />
    </Fragment>
)

export class HEXSelectorUserReportingList extends Component {
    render() {
        return (
            <List title="User Reports" {...this.props} pagination={<Pagination rowsPerPageOptions={[10, 25, 50, 100, 250]} />} filters={<CrashReportFilters />} bulkActionButtons={<CrashReportActions />}>
                <Datagrid rowClick="edit">
                    <TextField source="userId"></TextField>
                    <TextField source="timeStamp" />
                    <TextField source="clientVersion" />
                    <TextField source="exceptionType" />
                    <TextField source="stackTrace" component="pre"></TextField>
                    <ShowButton label="Details" />
                    <DeleteButton />
                </Datagrid>     
            </List>
        );
    }
}
const StackTraceField = ({ record }) => (
    <ol>
        {record.stackTraceDetails ? record.stackTraceDetails.map(item => (
            <li key={item.id}>
                {item.azureSearchLink ? <a href={item.azureSearchLink} target='_blank' rel="noreferrer">{item.frame}</a> : item.frame}
            </li>
        )) : ''}
    </ol>
);
StackTraceField.defaultProps = { addLabel: true };

export class HEXSelectorCrashReportDetail extends Component {
    render() {
        return (
            <Show {...this.props}>
                <SimpleShowLayout>
                    <ListButton label="Back To List" />
                    <EmailField source="userId"></EmailField>
                    <TextField source="timeStamp" />
                    <TextField source="exceptionType" />
                    <ArrayField label="Affected Versions" source="clientVersions">
                        <SingleFieldList>
                            <ChipField source="value" />
                        </SingleFieldList>
                    </ArrayField>
                    <ArrayField label="Affected Users" source="users">
                        <SingleFieldList>
                            <ChipField source="value" />
                        </SingleFieldList>
                    </ArrayField>
                    <StackTraceField source="stackTrace"></StackTraceField>
                    {/* <TextField source="stackTrace" component="pre"></TextField> */}
                    <DeleteButton />               
                </SimpleShowLayout>
            </Show>
        )
    }
}
